import { createStore } from 'vuex';

// Import general mixin for shared functionality.
import mixin from '../mixin';

export default createStore({
    state: {
        dictionary: {},
        dossiersTransferred: [],
        dossiersCurrent: [],
        dossiersClosed: [],
        dossiers: [],
        arrangements: [],
        deductions: [],
        dossiersClosedPerReason: [],
        dossiersCurrentPerStatus: [],
        rentalData: [],
        evictions: [],
        highContrast: false,
    },
    mutations: {
        setDictionary(state, dictionary) {
            state.dictionary = dictionary;
        },
        setDossiersTransferred(state, dossiersTransferred) {
            state.dossiersTransferred = dossiersTransferred;
        },
        setDossiersCurrent(state, dossiersCurrent) {
            state.dossiersCurrent = dossiersCurrent;
        },
        setDossiersClosed(state, dossiersClosed) {
            state.dossiersClosed = dossiersClosed;
        },
        setDossiers(state, dossiers) {
            state.dossiers = dossiers;
        },
        setArrangements(state, arrangements) {
            state.arrangements = arrangements;
        },
        setDeductions(state, deductions) {
            state.deductions = deductions;
        },
        setDossiersClosedPerReason(state, dossiersClosedPerReason) {
            state.dossiersClosedPerReason = dossiersClosedPerReason;
        },
        setDossiersCurrentPerStatus(state, dossiersCurrentPerStatus) {
            state.dossiersCurrentPerStatus = dossiersCurrentPerStatus;
        },
        setRentalData(state, rentalData) {
            state.rentalData = rentalData;
        },
        setEvictions(state, evictions) {
            state.evictions = evictions;
        },
        toggleHighContrast(state) {
            state.highContrast = !state.highContrast;
        },
    },
    getters: {
        getText: (state) => (key) => {
            return state.dictionary[key] || key;
        },
        getDossiersTransferred: (state) => {
            return state.dossiersTransferred;
        },
        getDossiersCurrent: (state) => {
            return state.dossiersCurrent;
        },
        getDossiersClosed: (state) => {
            return state.dossiersClosed;
        },
        getDossiers: (state) => {
            return state.dossiers.map(dossier => {
                return {
                    ...dossier,
                    dossier_nr: mixin.methods.parseDossierNr(dossier.dossier_nr),
                }
            });
        },
        getArrangements: (state) => {
            return state.arrangements.map(dossier => {
                return {
                    ...dossier,
                    dossier_nr: mixin.methods.parseDossierNr(dossier.dossier_nr),
                }
            });
        },
        getDeductions: (state) => {
            return state.deductions.map(dossier => {
                return {
                    ...dossier,
                    dossier_nr: mixin.methods.parseDossierNr(dossier.dossier_nr),
                }
            });
        },
        getDossiersClosedPerReason: (state) => {
            return state.dossiersClosedPerReason.map(dossier => {
                return {
                    ...dossier,
                    dossier_nr: mixin.methods.parseDossierNr(dossier.dossier_nr),
                }
            });
        },
        getDossiersCurrentPerStatus: (state) => {
            return state.dossiersCurrentPerStatus.map(dossier => {
                return {
                    ...dossier,
                    dossier_nr: mixin.methods.parseDossierNr(dossier.dossier_nr),
                }
            });
        },
        getRentalData: (state) => {
            return state.rentalData.map(dossier => {
                return {
                    ...dossier,
                    dossier_nr: mixin.methods.parseDossierNr(dossier.dossier_nr),
                }
            });
        },
        getEvictions: (state) => {
            return state.evictions.map(dossier => {
                return {
                    ...dossier,
                    dossier_nr: mixin.methods.parseDossierNr(dossier.dossier_nr),
                }
            });
        },
        getHighContrast: (state) => {
            return state.highContrast;
        },
    },
});
